import store from '@/store'

const routes = [{
    path: '/masterdata/users-list/:id',
    name: 'masterdatausers',
    props: true,
    component: () => import('@/views/main/modules/MasterData/UsersComponent.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'Users',
    },
},
{
    path: '/masterdata/department/:id',
    name: 'masterdatadepartments',
    component: () => import('@/views/main/modules/MasterData/DepartmentsComponent.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'Departments',
    },
},
{
    path: '/masterdata/department-access/:id',
    name: 'masterdatadepartmentaccess',
    component: () => import('@/views/main/modules/MasterData/DepartmentAccessComponent.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'Department Access',
    },
},
{
    path: '/masterdata/roles/:id',
    name: 'masterdataroles',
    component: () => import('@/views/main/modules/MasterData/RolesComponent.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })

    },
    meta: {
        requiresAuth: true,
        title: 'Roles',
    },
},
{
    path: '/masterdata/vehicles/:id',
    name: 'masterdatavehicles',
    component: () => import('@/views/main/modules/MasterData/VehiclesGroupComponent.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'Vehicles',
    },
},
{
    path: '/masterdata/warehouse/:id',
    name: 'masterdatawarehouse',
    component: () => import('@/views/main/modules/MasterData/WarehouseComponent.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'Warehouses',
    },
},
{
    path: '/masterdata/salesman/:id',
    name: 'masterdatasalesman',
    component: () => import('@/views/main/modules/MasterData/SalesmanComponent.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'Salesman',
    },
},
{
    path: '/masterdata/customer/:id',
    name: 'masterdatacustomer',
    component: () => import('@/views/main/modules/MasterData/CustomerComponent.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'Customers',
    },
},
{
    path: '/masterdata/vendor/:id',
    name: 'masterdatavendor',
    component: () => import('@/views/main/modules/MasterData/VendorComponent.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'Vendors',
    },
},
{
    path: '/masterdata/cluster/:id',
    name: 'masterdatacluster',
    component: () => import('@/views/main/modules/MasterData/ClusterComponent.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'Clusters',
    },
},
{
    path: '/masterdata/report-module/:id',
    name: 'masterdataReportModule',
    component: () => import('@/views/main/modules/MasterData/ReportModuleComponent.vue'),
    beforeEnter: (to, from, next) => {
    store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'Report Module',
    },
},
{
    path: '/masterdata/companies/:id',
    name: 'companies',
    component: () => import('@/views/main/modules/MasterData/Companies/CompaniesGroupComponent.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {});
    },
    meta: {
        requiresAuth: true,
        title: 'Companies',
    },
}]

export default routes;
